import { createReducer, on } from "@ngrx/store";
import { acabadoAdapter, continenteAdapter, tipoMaterialAdapter, usoMaterialAdapter, colorMaterialAdapter, ModuleState, espesorAdapter, disponibilidadAdapter, rangoPrecioAdapter, materialAdapater, caracteristicasMaterialAdapater } from "../state";
import * as fromAction from '../actions';
import { UnidadMedida } from '../models';
//import { getLanguageFromUrl, LanguageId } from '../language';

const maestrosInitState: ModuleState['maestros'] = {
  tipoMaterial: tipoMaterialAdapter.getInitialState(),
  acabado: acabadoAdapter.getInitialState(),
  usoMaterial: usoMaterialAdapter.getInitialState(),
  continente: continenteAdapter.getInitialState(),
  colorMaterial: colorMaterialAdapter.getInitialState(),
  espesor: espesorAdapter.getInitialState(),
  disponibilidad: disponibilidadAdapter.getInitialState(),
  rangoPrecio: rangoPrecioAdapter.getInitialState(),
  materiales: materialAdapater.getInitialState(),
  caracteristicasMaterial: caracteristicasMaterialAdapater.getInitialState(),
  all: null
}

export const maestrosReducer = createReducer(
  maestrosInitState,
  on(fromAction.loadMaestrosMaterial, (state, maestros) => {
    return {
      tipoMaterial: tipoMaterialAdapter.setAll(maestros.tipoMaterial, state.tipoMaterial),
      acabado: acabadoAdapter.setAll(maestros.acabado, state.acabado),
      usoMaterial: usoMaterialAdapter.setAll(maestros.usoMaterial, state.usoMaterial),
      continente: continenteAdapter.setAll(maestros.continente, state.continente),
      colorMaterial: colorMaterialAdapter.setAll(maestros.colorMaterial, state.colorMaterial),
      espesor: espesorAdapter.setAll(maestros.espesor, state.espesor),
      disponibilidad: disponibilidadAdapter.setAll(maestros.disponibilidad, state.disponibilidad),
      rangoPrecio: rangoPrecioAdapter.setAll(maestros.rangoPrecio, state.rangoPrecio),
      materiales: materialAdapater.setAll(maestros.materiales, state.materiales),
      caracteristicasMaterial: caracteristicasMaterialAdapater.setAll(maestros.caracteristicasMaterial, state.caracteristicasMaterial),
      all: maestros
    }
  })
)

export const detailsReducer = createReducer(
  [],
  on(fromAction.loadDetails, (state, { detalles }) => detalles)
)

export const materialesSimilaresReducer = createReducer(
  [],
  on(fromAction.loadMaterialesSimilares, (state, { materiales }) => materiales)
)

const defaultUnidadMedida: UnidadMedida = UnidadMedida.CM;//UnidadMedida = getLanguageFromUrl() === LanguageId.ENGLISH ? UnidadMedida.INCHES : UnidadMedida.CM;

export const unidadMedidaReducer = createReducer(
  defaultUnidadMedida,
  on(fromAction.changeUnidadMedida, (state, { unidad }) => unidad)
)
